export default __webpack_public_path__ + "static/media/2.a67c8095.jpg";